import {
  StackScrollTool,
} from "@cornerstonejs/tools";
import { useState, useEffect, useContext, useRef } from "react";
import {
  API_BASE_URL,
  APIs,
  COLORS,
  DEFAULT_TOOL,
  HP_META_TAGS,
  HP_OPERANDS,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
  XRAY_DEFAULT_TOOL,
  dicomWebURL,
  imageBaseURL,
  showPathologyForModalities,
} from "../../constants/Constants";
import {
  eventBus,
  getViewport,
  getViewportByIdAndRenderingEngine,
  getViewportByIdAndDefRenderingEngine,
  renderViewports,
  rerenderViewport
} from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import ViewportContext from "./ViewportContext";
import { eventTarget, getEnabledElement, getRenderingEngine  } from "@cornerstonejs/core";
import { uuidv4 } from "@cornerstonejs/core/utilities";
import { Enums, annotation } from "@cornerstonejs/tools";
import toolStyle from "@cornerstonejs/tools/annotation/config/ToolStyle";
import { patientViewerState } from "../../pages/Annotations/helper/initialData";
import studyviewerContext from "./StudyviewerContext";
import { resizeViewport } from "../../pages/StudyViewer/helpers/CornerstoneViewportService";
import {
  empty3DJsonData,
  getAllFourCoordinates,
  getTextAnnotation3DObject,
  getTextAnnotationLegacyData,
  getUpdatedJson,
} from "../../pages/StudyViewer/helpers/BoundingBoxUtilities";
import loaderContext from "../loader/LoaderContext";
import toastContext from "../toast/ToastContext";
import { removeAnnotation } from "@cornerstonejs/tools/annotation/annotationState";
import ThumbnailContext from "./ThumbnailContext";
import {enableStackScrollSync, disableStackScrollSync} from "../../pages/StudyViewer/helpers/StackScrollSyncService";
import { getMetadataTagValue } from "../../pages/StudyViewer/helpers/CornerstoneService";
import { getAllThumbnailViewports } from "../../pages/StudyViewer/helpers/CornerstoneThumbnailService";
import { isMobile } from "react-device-detect";
import { loadAndCacheImage, loadImage } from "@cornerstonejs/core/loaders/imageLoader";
import userContext from "../users/UserContext";

const csToolsEvents = Enums.Events;

const ViewportState = (props) => {
  const {
    priorStudyData,
    reportDoneStatus,
    reportingDoctor,
    studyBoundingBox,
    studyData,
    setStudyBoundingBox,
    studyTextTool,
    viewportLoading,
    isGenki,
    studyParentId,
    parentChildReportsObj,
    alreadyAddedBB, setAlreadyAddedBB,
    hpDataList,
    appliedHp,
    setAppliedHp,
    setHpLoading,
    setIsHpApplied,
    showPathologyOptions,
    hpPercentageMap, setHpPercentageMap,
    hpViewportMap, setHpViewportMap,
    setHpNotFound,
    maskedBoundingBox,
    maskImages, setMaskImages
  } = useContext(studyviewerContext);

  const {
    activeModality,
    activeThumbnailIndex,
    activeStudyId,
    setStackScrollActiveThumbnailIndex,
    changeActiveThumbnailIndex,
    setActiveModality,
    setActiveStudyId,
    thumbnailLoadingComplete
  } = useContext(ThumbnailContext);

  const {roles, username, userId} = useContext(userContext);

  const imageCacheRef = useRef(new Map());


  const [isUserInfoClicked, setIsUserInfoClicked] = useState(false);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [activeViewportIndex, setActiveViewportIndex] = useState(0);
  const [activeMPRViewportIndex, setActiveMPRViewportIndex] = useState(0);
  const [patientViewer, setPatientViewer] = useState(patientViewerState);
  const [testPatientViewerParent, setTestPatientViewerParent] = useState({});
  const [disableAddPathology, setDisableAddPathology] = useState(false);
  const [addedAnnotation, setAddedAnnotation] = useState([]);
  const [archivedPathology, setArchivedPathology] = useState(null);
  const [addedStoreAnnotation, setAddedStoreAnnotation] = useState([]);
  const [contextMenuOpen, setContextMenuOpen] = useState({
    open: false,
    mouseEvt: null,
    data: null,
    showRemove: false,
  });
  const [allowAddingTextAnnotation, setAllowAddingTextAnnotation] =
    useState(false);
  const [showCompare, setShowCompare] = useState(false);
  const [isMPRActive, setIsMPRActive] = useState(false);
  const [isSagittalActive, setIsSagittalActive] = useState(false);
  const [isAxialActive, setIsAxialActive] = useState(false);
  const [isCoronalActive, setIsCoronalActive] = useState(false);
  const [isCompareActive, setIsCompareActive] = useState(false);
  const [showImpressions, setShowImpressions] = useState(false);
  const [boundingBox, setBoundingBox] = useState({});
  const [annotationData, setAnnotationData] = useState({});
  const [maskingProfileData, setMaskingProfileData] = useState({});
  const [annotationDataAI, setAnnotationDataAI] = useState({});
  const [currentActiveTag, setCurrentActiveTag] = useState({
    id: undefined,
    color: undefined,
  });
  const [activeId, setActiveId] = useState("");
  const [isMPREnabled, setIsMPREnabled] = useState(true);
  const [activeColor, setActiveColor] = useState("");
  const [isMPRViewportActivate, setIsMPRViewportActivated] = useState(false);
  const [activeMPRTool, setActiveMPRTool] = useState("");
  const [previousActiveMPRTool, setPreviousActiveMPRTool] = useState("");
  const [viewportElements, setViewportElements] = useState([]);
  const [mprViewportElements, setMprViewportElements] = useState({});
  const [mprLoading, setMprLoading] = useState(true);
  const [mprSeriesData, setMprSeriesData] = useState({});
  let tempViewportElements = [];
  const [activeViewportModality, setActiveViewportModality] = useState("");
  const [viewportRow, setViewportRow] = useState(1);
  const [viewportColumn, setViewportColumn] = useState(1);
  const [activeTool, setActiveTool] = useState(StackScrollTool.toolName);
  const [previousActiveTool, setPreviousActiveTool] = useState();
  const [showOverlay, setShowOverlay] = useState(true);
  const [volumeId, setVolumeId] = useState("");
  const [dragEvent, setDragEvent] = useState(false);
  const [thumbnailDropEvent, setThumbnailDropEvent] = useState(false);
  const [thumbnailClickEvent, setThumbnailClickEvent] = useState(false);
  const [allTextToolAnnotation, setAllTextToolAnnotation] = useState({});
  const [editWarning, setEditWarning] = useState({
    show: false,
    name: "",
    id: null,
    success: false,
    color: COLORS.warning,
  });

  const [maskingConfirm, setMaskingConfirm] = useState({
    show: false,
    name: "",
    id: null,
    success: false,
    color: COLORS.warning,
  });
  const [viewportSeriesData, setViewportSeriesData] = useState(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_COLUMN * VIEWPORT_ROW; i++) {
      array.push({ study: "", stack: "", modality: "" });
    }
    return array;
  });

  const [showPriorStudyTopBar, setShowPriorStudyTopBar] = useState(false);
  const [viewportStates, setViewportStates] = useState({});
  const [boundingBoxMode, setBoundingBoxMode] = useState(false);

  const [boundingBoxAdding, setBoundingBoxAdding] = useState(null);
  //   [
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  //   { study: "", stack: "", modality: "" },
  // ]);
  const [isCineEnabled, setIsCineEnabled] = useState(false);
  const [isMPRCineEnabled, setIsMPRCineEnabled] = useState(false);
  const [isSynchronizedEnabled, setIsSynchronizedEnabled] = useState(false);
  const [isReferenceLinesEnabled, setIsReferenceLinesEnabled] = useState(false);
  const [annotationAddedSuccess, setAnnotationAddedSuccess] = useState(false);
  const [isChildStudyActive, setIsChildStudyActive] = useState(false);
  const [isReferenceLineActivated, setIsReferenceLineActivated] =
    useState(false);
  const [viewportLoadingComplete, setViewportLoadingComplete] =
    useState(false);
  const [mprViewportLoaderRunning, setMPRViewportLoaderRunning] =
    useState(true);
  const addedEvt = csToolsEvents.ANNOTATION_ADDED;
  const completedEvt = csToolsEvents.ANNOTATION_COMPLETED;
  const updatedEvt = csToolsEvents.ANNOTATION_MODIFIED;
  const [imageLoadedOnViewport, setImageLoadedOnViewport] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [viewportHpLayout, setViewportHpLayout] = useState(new Map());
  const [viewportHpImage, setViewportHpImage] = useState(new Map());
  const [viewportOldState, setViewportOldState] = useState({
    viewportIndex: 1,
    isDoubleClicked: false,
    largeImage: false,
    reportMenu: null,
    seriesMenu: null,
    showPathologyOptions: showPathologyOptions,
    viewportRow: viewportRow,
    viewportColumn: viewportColumn,
    loadOldViewportStatus: false,
  });

  const [viewportDoubleClickIndex, setViewportDoubleClickIndex] = useState(-1);
  const [viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst] = useState(-1); 

  const [isSrSelected, setIsSrSelected] = useState(false);
  
  const [hPThumbnailIds, setHPThumbnailIds] = useState([]);

  const [maskingProfileState, setMaskingProfileState] = useState({
    isActive: false,
    color: '#0078d4', // Or some default mask color
    id: 'mask-profile-001', // Use consistent ID for mask
    name: 'Masking Profile',
  });

  const [isCreatingMaskingProfile, setIsCreatingMaskingProfile] = useState(false);
  const [isMaskingEnabled, setIsMaskingEnabled] = useState(false);
  

  const[isCropEnable , setIsCropEnable] = useState(false);

  const getViewportProperties = (viewport, scale, voi) => ({
    properties : viewport.getProperties() || null,
    camera : viewport.getCamera() || null,
    actor : viewport.getActor() || null,
    actors : viewport.getActors() || null,
    imageData : viewport.getImageData() || null,
    currentImageIndex : viewport.getCurrentImageIdIndex() || null,
  });


  const updateViewportProperties = (viewportIndex, viewportInstance, scale, voi) => {
    if(viewportInstance){
      const properties = getViewportProperties(viewportInstance, scale, voi);

      setViewportStates((prevStates) => ({
        ...prevStates,
        [viewportIndex]: {
          ...prevStates[viewportIndex],
          ...properties,
        },
      }));
    }
  };


  useEffect(() => {
    if (activeStudyId == studyParentId) {
      setIsChildStudyActive(false);
    } else {
      setIsChildStudyActive(true);
    }
    if (Object.keys(parentChildReportsObj)?.length > 0) {
      if (
        showPathologyForModalities.includes(
          parentChildReportsObj[activeStudyId]?.modality
        )
      ) {
        setShowPriorStudyTopBar(true);
      } else {
        setShowPriorStudyTopBar(false);
      }
    }
  }, [activeStudyId]);

  useEffect(() => {
    if (
      viewportLoading.viewport1Loading == true ||
      viewportLoading.viewport2Loading == true ||
      viewportLoading.viewport3Loading == true ||
      viewportLoading.viewport4Loading == true
    ) {
      if (
        annotationAddedSuccess == true &&
        Object.keys(annotationData).length == 0
      ) {
        if (studyBoundingBox.length > 0) {
          addBoundingBoxToViewport(studyBoundingBox);
        }
      }
    }
  }, [viewportLoading, annotationAddedSuccess]);

  useEffect(() => {
    if (
      viewportLoading.viewport1Loading == true ||
      viewportLoading.viewport2Loading == true ||
      viewportLoading.viewport3Loading == true ||
      viewportLoading.viewport4Loading == true
    ) {
      if (maskedBoundingBox.length > 0 && reportDoneStatus < 2 && reportingDoctor !== null && reportingDoctor == username) {
          setIsMaskingEnabled(true);
          removeOldMaskedAnnotations();
          addMaskedBoundingBoxesToViewport();
          //addBlackMaskOverlayOnViewport();
      } else{
        setIsMaskingEnabled(false);
      }
    }
  }, [viewportLoading, annotationAddedSuccess, maskedBoundingBox]);

  const removeOldMaskedAnnotations = () => {
    console.log("remove all annotation");
    const annotationManager = annotation.state.getAnnotationManager();
    const allAnnotations = annotationManager.getAnnotations();
    annotationManager.removeAllAnnotations();
    // console.log("remove all annotation", allAnnotations);
    // Object.values(allAnnotations).forEach(annotationArray => {
    //   annotationArray.forEach(annotation => {
    //     if (annotation.metadata?.source === 'masked') {
    //       annotationManager.removeAnnotation(annotation.annotationUID);
    //       console.log("removing annotation", annotation.annotationUID);
    //     }
    //   });
    // });
    renderViewports();
  };

  const addMaskedBoundingBoxesToViewport = async (maskedData = maskedBoundingBox) => {
    console.log("adding masked bounding box", maskedData, viewportSeriesData);
    for(let viewportIndex in viewportSeriesData){
      viewportIndex = parseInt(viewportIndex);
      console.log("viewportIndex", viewportIndex);
      const viewportData = viewportSeriesData[viewportIndex];
      const activeViewport = await getViewport(viewportIndex);
      if (!activeViewport) return;

      const { imageData } = activeViewport.getImageData?.() || {};
      if (!imageData) {
        console.warn("Image data not available.");
        return;
      }

      const defaultProfile = maskedData.find(
        (entry) => entry.imageId === -1 && entry.imageUrl === "DEFAULT"
      );

      const frameOfReferenceUID = activeViewport.getFrameOfReferenceUID();
    
      viewportData.stack.images.forEach((image, i) => {
        const { id: imageId } = image;

        let profile = maskedData.find(
          (entry) => entry.imageId === imageId
        );

        let dicomUri;

        if (!profile && defaultProfile) {
          profile = { ...defaultProfile };
          dicomUri = viewportData.stack.imageIds[i];
        } else if (profile) {
          dicomUri = API_BASE_URL.replace(/^https?/, "wadouri") + APIs.GETIMAGEDATAWITHFILESIZE + profile.imageId + "/" + profile.imageUrl;
        }

        if (!profile) {
          console.log(`No profile found for imageId ${imageId}`);
          return;
        }
    
        profile.annotationMeasurements.forEach((meas) => {
          //console.log("adding bounding box", meas);
          const measurement = JSON.parse(meas.measurementData);
          const { start, end, annotationUID } = measurement;

          const allFourPoints = getAllFourCoordinates(measurement);
          const updatedPoints = allFourPoints.map((pt) => imageData.indexToWorld(pt));

          const newBoundingBox = getUpdatedJson(dicomUri, updatedPoints, annotationUID);
          newBoundingBox.annotation.metadata = {
            ...newBoundingBox.annotation.metadata,
            source: "masked",
            imageId: imageId,
            FrameOfReferenceUID: frameOfReferenceUID
          };

          const annotationUIDAdded = annotation.state.addAnnotation(newBoundingBox.annotation);
          annotation.visibility.setAnnotationVisibility(annotationUIDAdded, true);

          toolStyle.setAnnotationStyles(annotationUIDAdded, {
            lineWidth: "2px",
            textBoxLinkLineWidth: "0",
            textBoxFontSize: "0px",
            color: profile.color,
            colorSelected: profile.color,
            colorHighlighted: profile.color,
          });
        });
      });
      rerenderViewport();
    }
  };

  const addBlackMaskOverlayOnViewport = async () => {
    const viewport = document.querySelector(`#viewport_${activeViewportIndex}`);
    if (!viewport) return;

    const cornerstoneCanvas = viewport.querySelector("canvas");
    if (!cornerstoneCanvas) {
      console.warn("Cornerstone canvas not found");
      return;
    }

    let overlayCanvas = viewport.querySelector(".mask-overlay");
    if (!overlayCanvas) {
      overlayCanvas = document.createElement("canvas");
      overlayCanvas.className = "mask-overlay";
      overlayCanvas.style.position = "absolute";
      overlayCanvas.style.top = "0";
      overlayCanvas.style.left = "0";
      overlayCanvas.style.pointerEvents = "none";
      overlayCanvas.style.zIndex = 10; // on top of cornerstone canvas
      viewport.appendChild(overlayCanvas);
    }

    // Match overlay canvas size & position to cornerstone canvas
    overlayCanvas.width = cornerstoneCanvas.width;
    overlayCanvas.height = cornerstoneCanvas.height;
    overlayCanvas.style.width = cornerstoneCanvas.style.width;
    overlayCanvas.style.height = cornerstoneCanvas.style.height;

    const ctx = overlayCanvas.getContext("2d");
    ctx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);

    const viewportObj = await getViewport(activeViewportIndex);
    if (!viewportObj) {
      console.warn("Viewport object not found");
      return;
    }
    const { imageData } = viewportObj.getImageData?.() || {};
    if (!imageData) {
      console.warn("Image data not available");
      return;
    }

    let currentImageIndex = viewportObj.getCurrentImageIdIndex();
    let imageId = viewportSeriesData[activeViewportIndex].stack.images[currentImageIndex].id;
    
      const profile = maskedBoundingBox.find((entry) => entry.imageId === imageId);

      if (!profile) return;

      profile.annotationMeasurements.forEach((meas) => {
        const measurement = JSON.parse(meas.measurementData);
        const allFourPoints = getAllFourCoordinates(measurement);

        // Convert world points to canvas coordinates
        const canvasPoints = allFourPoints.map((pt) => {
          // pt is index coords, convert to world then to canvas:
          const worldPt = imageData.indexToWorld(pt);
          return viewportObj.worldToCanvas(worldPt);
        });

        // Calculate bounding rectangle in canvas coords
        const xs = canvasPoints.map((p) => p[0]);
        const ys = canvasPoints.map((p) => p[1]);
        const x = Math.min(...xs);
        const y = Math.min(...ys);
        const width = Math.max(...xs) - x;
        const height = Math.max(...ys) - y;

        // Draw translucent black rectangle on overlay canvas
        ctx.fillStyle = "rgba(0, 0, 0, 1)";
        ctx.fillRect(x, y, width, height);
      });
  };

  const handleAddMaskingProfile = () => {
    console.log("Add masking profile clicked");
    let color = maskedBoundingBox.length > 0 ? maskedBoundingBox[0].color : "#0078D4";

    const data = {
      id: "mask-profile-001",
      backgroundColor: color,
    };

    activeMaskingProfileRef.current = data;
    boundingBoxModeRef.current = true;

    setBoundingBoxMode(true); // Enable bounding box drawing
    setActiveTool("RectangleROI");

     setEditWarning({
        show: true,
        name: "Kindly mark the area for Masking",
        success: true,
        color: color,
      });

    eventTarget.removeEventListener(addedEvt, startCallback);
    eventTarget.removeEventListener(completedEvt, completeCallback);

    eventTarget.addEventListener(addedEvt, startCallback);
    eventTarget.addEventListener(completedEvt, completeCallback);
  };

  const startCallback = (e) => {
      if (!boundingBoxModeRef.current) return;

      console.log("Bounding box drawing started");
      setBoundingBoxAdding("enabled");

    };

    const completeCallback = (e) => {
      if (!boundingBoxModeRef.current) return;

      console.log("Bounding box completed", e);
      const annotationDetail = e.detail;

      applyMaskAnnotationToCurrentImage(annotationDetail, maskingProfileState);

      setEditWarning({
        show: true,
        name: "Click On Save",
        success: true,
        color: maskingProfileState.color,
      });

      setBoundingBoxAdding("disabled");
      setActiveTool("RectangleROI");
    };

  const applyMaskAnnotationToCurrentImage = async (annotationDetail, profile) => {
    console.log("applyMaskAnnotationToAllImages", annotationDetail);

    const viewport = await getViewport(activeViewportIndex);
    if (!viewport) {
      console.log("viewport is not running");
      return;
    }

    const imageId = extractImageUrl(viewport.getCurrentImageId());

    if (!maskingProfileData[imageId]) {
      maskingProfileData[imageId] = {};
    }
    if (!maskingProfileData[imageId][profile.id]) {
      maskingProfileData[imageId][profile.id] = [];
    }

    const clonedAnnotation = structuredClone(annotationDetail);
    maskingProfileData[imageId][profile.id].push(clonedAnnotation);

    handleColorChange(profile.id, profile.color, maskingProfileData[imageId]);

    console.log(maskingProfileData);

    renderViewports();
  };

  useEffect(() => {
    if (allowAddingTextAnnotation) {
      if (studyTextTool.length > 0) {
        setTimeout(() => {
          addTextAnnotationToViewport(studyTextTool);
        }, 1000);
      }
    }
  }, [allowAddingTextAnnotation]);

  const addMeasurement = (csToolsEvent, id, name, color) => {
    try {
      const annotationAddedEventDetail = csToolsEvent.detail;
      if (annotationAddedEventDetail != undefined) {
        setEditWarning(() => {
          let newVal = { ...editWarning };
          newVal.show = true;
          newVal.name = "Marking " + name;
          newVal.success = true;
          newVal.color = color;
          newVal.id = id;
          return newVal;
        });
        const {
          annotation: { metadata, annotationUID },
        } = annotationAddedEventDetail;
        const { toolName } = metadata;
        if (id != "")
          annotationToMeasurement(
            toolName,
            annotationAddedEventDetail,
            id,
            color
          );
        
      } 
    } catch (error) {
      console.warn("Failed to update measurement:", error);
    }
  };

  useEffect(() => {
    eventBus.on("contextMenuAdd", (evtData) => {
      setContextMenuOpen(() => {
        const newVal = { ...contextMenuOpen };
        newVal.open = evtData.show;
        newVal.mouseEvt = evtData.mouseEvent;
        newVal.data = evtData.data;
        newVal.showRemove = evtData.showRemove;
        return newVal;
      });
    });
  }, []);

  const extractImageUrl = (s) => {
    const match = s.match(/\/get\/\d+\/(.+)/);
    return match ? match[1] : null;
  };

  const annotationToMeasurement = (
    source,
    sourceAnnotationDetail,
    id,
    color,
    isUpdate = false
  ) => {
    if (source == "RectangleROI") {
      const activeViewport = getViewportByIdAndRenderingEngine(sourceAnnotationDetail.viewportId, sourceAnnotationDetail.renderingEngineId);

      let imageURL = activeViewport.getCurrentImageId();
      imageURL = extractImageUrl(imageURL);

      let boundingBoxTemp = annotationData;
      if (!boundingBoxTemp[imageURL]) {
        boundingBoxTemp[imageURL] = {};
      }
      if (!boundingBoxTemp[imageURL][id]) {
        boundingBoxTemp[imageURL][id] = [];
      }
      boundingBoxTemp[imageURL][id].push(sourceAnnotationDetail);
      handleColorChange(id, color, boundingBoxTemp[imageURL]);
      setDisableAddPathology(false);

    }
  };

  const restoreBoundingBox = async (studyBoundingBox, pathologyId) => {
    console.log("***************************************");
    console.log(annotationData);
    console.log(annotationDataAI);
    handleRemoveWarning();
   
    const activeViewport = await getViewport(activeViewportIndex);
    let isRender = false;
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);
    for (let imageURLVar in annotationData) {
      if(imageURLVar == imageURL) {
        for (let pathId in annotationData[imageURLVar]) {
          if (pathId == pathologyId) {
            annotationData[imageURLVar][pathId].forEach((item) => {
              let annotationUID = item.annotation.annotationUID;
              annotation.state.removeAnnotation(annotationUID);
              isRender = true;
            });
          }
        }
      }
    }
    
    annotationData[imageURL][pathologyId] = [];

     for (let imageURLVar in annotationDataAI) {
      if(imageURLVar == imageURL) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == pathologyId) {
            annotationDataAI[imageURLVar][pathId].forEach((item) => {
              let annotation_obj = JSON.parse(JSON.stringify(item));
              annotation.state.addAnnotation(annotation_obj.annotation);
              annotationData[imageURL][pathologyId].push(annotation_obj);
              isRender = true;
            });
          }
        }
      }
    }
    activeViewport.render();
  };

  const addTextAnnotationToDatabase = async (textAnnotationObject, addOrUpdate) => {
    const activeViewport = await getViewport(activeViewportIndex);
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);

    const { imageData } = activeViewport.getImageData();
    let boundingBoxTemp = allTextToolAnnotation;
    if (!boundingBoxTemp[imageURL]) {
      boundingBoxTemp[imageURL] = [];
    }

    setTimeout(() => {

      let start = imageData.worldToIndex(
        textAnnotationObject.data.handles.points[0]
      );
    let end = imageData.worldToIndex(
      textAnnotationObject.data.handles.points[1]
    );
  let worldPos = imageData.worldToIndex(
    textAnnotationObject.data.handles.textBox.worldPosition
    );
    let topLeft = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.topLeft
    );
    let topRight = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.topRight
    );
    let bottomLeft = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.bottomLeft
    );
    let bottomRight = imageData.worldToIndex(
      textAnnotationObject.data.handles.textBox.worldBoundingBox.bottomRight
    );
  
  let height = Math.abs(bottomLeft[1] - topLeft[1]);
    let width = Math.abs(topRight[0] - topLeft[0]);

    let top = topLeft[1];
    let left = topLeft[0];

    const boundingBox = { height, width, top, left };
    const annotationUID = textAnnotationObject.annotationUID;
    const cameraFocalPoint = textAnnotationObject.metadata.cameraFocalPoint;
    const sliceIndex = textAnnotationObject.metadata.sliceIndex;
    const cachedStats = textAnnotationObject.data.cachedStats;

    const text = textAnnotationObject.data.text;
    const arrowFirst = textAnnotationObject.data.handles.arrowFirst;
    const obj = { start, end, text, worldPos, boundingBox, annotationUID, cameraFocalPoint, sliceIndex, cachedStats, arrowFirst };

    const updatedJsonFormate = getTextAnnotationLegacyData(obj);
    if(addOrUpdate){
      boundingBoxTemp[imageURL].push(JSON.stringify(updatedJsonFormate));
    }else{
      const index = boundingBoxTemp[imageURL].findIndex(item => {
        const parsedItem = JSON.parse(item);
        return parsedItem.annotationUID === annotationUID;
      });

      if (index !== -1) {
        boundingBoxTemp[imageURL][index] = JSON.stringify(updatedJsonFormate);
      } else {
        console.warn(`Annotation with UID ${annotationUID} not found for update.`);
      }
    }
    
    setAllTextToolAnnotation(boundingBoxTemp);
  },10)
  };

  const addTextAnnotationFromDatabaseToViewport = async (
    imageURL,
    e,
    tempTextAnnotationData
  ) => {
    // let obj = JSON.parse(e);

    annotation.state.addAnnotation(e);

    let boundingBoxTemp = allTextToolAnnotation;
    if (!boundingBoxTemp[imageURL]) {
      boundingBoxTemp[imageURL] = [];
    }
    boundingBoxTemp[imageURL].push(tempTextAnnotationData);
    setAllTextToolAnnotation(boundingBoxTemp);
  };

  const updateBBPosition = async(studyBoundingBox, runUpdate, showBB, pathId ) => {
    const activeViewport = await getViewport(activeViewportIndex);
    
    if (activeViewport != null || activeViewport != undefined) {
      studyBoundingBox.map((ele) => {
        var imageURL = ele.imageUrl;


        const dicomBaseURL = API_BASE_URL.startsWith("https")
          ? API_BASE_URL.replace("https", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL
          : API_BASE_URL.replace("http", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL;
        ele?.annotationMeasurements.map((ele, index) => {
          if(((pathId == null || pathId == undefined) && (annotationData[imageURL] != undefined && annotationData[imageURL][ele.id] != undefined)) || ele.id === pathId){   
            const { imageData, dimensions } = activeViewport?.getImageData();
            // let jsonDataBoundingBox = JSON.parse(ele.measurementData);
            let allFourPoints = getAllFourCoordinates(
              JSON.parse(ele.measurementData)
            );

            let updatedPoints = [];
            updatedPoints.push(imageData.indexToWorld(allFourPoints[0]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[1]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[2]));
            updatedPoints.push(imageData.indexToWorld(allFourPoints[3]));

            let newBoundingBox = getUpdatedJson(
              dicomBaseURL,
              updatedPoints,
              JSON.parse(ele.measurementData).annotationUID
            );
            if (showBB != undefined) {
              if(showBB != undefined){
                newBoundingBox.annotation.isVisible = showBB;
              }
            }else{
              newBoundingBox.annotation.isVisible = annotationData[imageURL] != undefined && annotationData[imageURL][ele.id] != undefined ? true : false;
            }
            
            const annotationVisibility = newBoundingBox.annotation.isVisible;
            const annotationUID = annotation.state.addAnnotation(newBoundingBox.annotation);
            annotation.visibility.setAnnotationVisibility(annotationUID, annotationVisibility);
            
            toolStyle.setAnnotationStyles(newBoundingBox.annotation.annotationUID, {
              lineWidth: "2px",
              textBoxLinkLineWidth: "0",
              textBoxFontSize: "0px",
              color: ele.color,
              colorSelected: ele.color,
              colorHighlighted: ele.color,
            });
          }
        });
        activeViewport.render();
      });
    }
   
  }

  const addBoundingBoxToViewport = async (studyBoundingBox) => {
    let manualData = annotationData;
    let data = {};
    const activeViewport = await getViewport(activeViewportIndex);
    let unlockedAnnotation = [];
    let lockedAnnotation = [];
    if (activeViewport != null || activeViewport != undefined) {
      studyBoundingBox.map((ele) => {
        var imageURL = ele.imageUrl;

        if (addedStoreAnnotation.length > 0) {
          addedStoreAnnotation.map((ele) => {
            if (ele.id != undefined && !data[imageURL] && imageURL != null) {
              data[imageURL] = {};
            }
            if (!data[imageURL][ele.id]) {
              data[imageURL][ele.id] = [];
            }
            if (
              ele.is_locked == false &&
              ele.is_annotated == false &&
              ele.ai_predicted == 1
            ) {
              unlockedAnnotation.push(ele.id);
            } else {
              lockedAnnotation.push(ele.id);
            }
          });
        }

        const dicomBaseURL = API_BASE_URL.startsWith("https")
          ? API_BASE_URL.replace("https", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL
          : API_BASE_URL.replace("http", "wadouri") +
            APIs.GETIMAGEDATAWITHFILESIZE + ele.imageId + "/" +
            imageURL;
        ele?.annotationMeasurements.map((ele, index) => {
          const { imageData, dimensions } = activeViewport?.getImageData();
          // let jsonDataBoundingBox = JSON.parse(ele.measurementData);
          let allFourPoints = getAllFourCoordinates(
            JSON.parse(ele.measurementData)
          );

          let updatedPoints = [];
          updatedPoints.push(imageData.indexToWorld(allFourPoints[0]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[1]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[2]));
          updatedPoints.push(imageData.indexToWorld(allFourPoints[3]));

          let newBoundingBox = getUpdatedJson(
            dicomBaseURL,
            updatedPoints,
            JSON.parse(ele.measurementData).annotationUID
          );
          let flag = true;
          if (ele.id != undefined) {
            if (data[imageURL][ele.id]?.length > 0) {
              data[imageURL][ele.id].map((item, index) => {
                if (
                  item.annotation.annotationUID ==
                  newBoundingBox.annotation.annotationUID
                ) {
                  flag = false;
                  return;
                }
              });
            }
            if (flag) {
              let bb =  JSON.parse(JSON.stringify(newBoundingBox));
              data[imageURL][ele.id]?.push(bb);
            }
          }
          if (unlockedAnnotation.includes(ele.id)) {
            newBoundingBox.annotation.isVisible = false;

          }
          addToViewport(
            newBoundingBox,
            ele.id,
            ele.color,
            dicomBaseURL,
            manualData,
            !unlockedAnnotation.includes(ele.id)
          );
        });
      });
      if(!alreadyAddedBB){
        let aiData = {};
        let lockedData = {};
        let imageUrl = "";
        for (const key in data) {
          imageUrl = key;
        }
  
        aiData = removeAnnotationsByIds(data, imageUrl, lockedAnnotation);
        lockedData = removeAnnotationsByIds(data, imageUrl, unlockedAnnotation);
        setAnnotationDataAI(aiData);
        setAnnotationData(lockedData);
        setAlreadyAddedBB(true);
      setTimeout(() => {
        setActiveTool("RectangleROI");
      }, 500);
      setTimeout(() => {
        setPreviousActiveTool("RectangleROI");
        // setActiveTool(StackScrollTool.toolName);
        handleDefaultToolChange();
      }, 600);
      }
    }
  };

  function removeAnnotationsByIds(state, imageURL, idsToRemove) {
    
    const newState = { ...state };
    for (const key in newState) {
      const imageObject = { ...newState[key] };
      for (const id of idsToRemove) {
        delete imageObject[id];
      }
      newState[key] = imageObject;
    }
    
    return newState;
  }
  const addTextAnnotationToViewport = async (studyTextTool) => {
    const activeViewport = await getViewport(activeViewportIndex);
    if (activeViewport != null || activeViewport != undefined) {
      const { imageData, dimensions } = activeViewport?.getImageData();

      studyTextTool.map((ele) => {
        var imageURL = ele.imageUrl;
        ele?.annotationMeasurements.map((ele, index) => {
          const tempTextAnnotationData = JSON.parse(ele.measurementData);
          const { viewPlaneNormal, viewUp } = activeViewport.getCamera();
          const start = imageData.indexToWorld([
            tempTextAnnotationData?.handles?.start.x,
            tempTextAnnotationData?.handles?.start.y,
            0,
          ]);
          const end = imageData.indexToWorld([
            tempTextAnnotationData?.handles?.end.x,
            tempTextAnnotationData?.handles?.end.y,
            0,
          ]);
          const worldPosition = imageData.indexToWorld([
            tempTextAnnotationData.handles?.textBox.x,
            tempTextAnnotationData.handles?.textBox.y,
            0,
          ]);
          let top = tempTextAnnotationData?.handles?.textBox.boundingBox.top;
          let left = tempTextAnnotationData?.handles?.textBox.boundingBox.left;
          let height =
            tempTextAnnotationData?.handles?.textBox?.boundingBox.height;
          let width =
            tempTextAnnotationData?.handles?.textBox.boundingBox.width;

          const topLeft = imageData.indexToWorld([left, top, 0]);
          const topRight = imageData.indexToWorld([left + width, top, 0]);
          const bottomLeft = imageData.indexToWorld([left, top + height, 0]);
          const bottomRight = imageData.indexToWorld([
            left + width,
            top + height,
            0,
          ]);
          const text = tempTextAnnotationData.text;
          const annotationUID = tempTextAnnotationData.annotationUID
            ? tempTextAnnotationData.annotationUID
            : uuidv4();
          if (!tempTextAnnotationData.annotationUID) {
            tempTextAnnotationData["annotationUID"] = uuidv4();
            ele.measurementData = JSON.stringify(tempTextAnnotationData);
          }
          const cameraFocalPoint = tempTextAnnotationData.cameraFocalPoint;
          const sliceIndex = tempTextAnnotationData.sliceIndex;
          const cachedStats = tempTextAnnotationData.cachedStats;
          const arrowFirst = tempTextAnnotationData.arrowFirst;
          const updatedAnnotationJson = getTextAnnotation3DObject(
            viewPlaneNormal,
            viewUp,
            activeViewport.getFrameOfReferenceUID(),
            (isGenki ? imageBaseURL : dicomWebURL) + imageURL,
            start,
            end,
            worldPosition,
            topLeft,
            topRight,
            bottomLeft,
            bottomRight,
            text,
            annotationUID,
            cameraFocalPoint, 
            sliceIndex, 
            cachedStats,
            arrowFirst
          );
          if (annotationUID != undefined) {
            addTextAnnotationFromDatabaseToViewport(
              imageURL,
              updatedAnnotationJson,
              ele.measurementData
            );
          }
        });
      });

      setTimeout(() => {
        setActiveTool("ArrowAnnotate");
      }, 200);
      setTimeout(() => {
        setPreviousActiveTool("ArrowAnnotate");
        setActiveTool(StackScrollTool.toolName);
      }, 300);
    }
  };

  const addToViewport = (
    jsonParsed,
    id,
    color,
    imageURL,
    manualData,
    visible
  ) => {

    // Add annotation
    const annotationUID = annotation.state.addAnnotation(jsonParsed.annotation);
    annotation.visibility.setAnnotationVisibility(annotationUID, visible);
    
    toolStyle.setAnnotationStyles(jsonParsed.annotation.annotationUID, {
      lineWidth: "2px",
      textBoxLinkLineWidth: "0",
      textBoxFontSize: "0px",
      color: color,
      colorSelected: color,
      colorHighlighted: color,
    });
    // if(!studyPredArray.includes(id)){
    if (visible)
      annotationToMeasurementTemp(
        "RectangleROI",
        jsonParsed,
        id,
        color,
        imageURL,
        manualData
      );

    resizeViewport();
    // }
  };

  const annotationToMeasurementTemp = (
    source,
    sourceAnnotationDetail,
    id,
    color,
    imageURL,
    manualData
  ) => {
    if (source == "RectangleROI") {
      imageURL = extractImageUrl(imageURL);
      let boundingBoxTemp = manualData;
      if (!boundingBoxTemp[imageURL]) {
        boundingBoxTemp[imageURL] = {};
      }
      if (!boundingBoxTemp[imageURL][id]) {
        boundingBoxTemp[imageURL][id] = [];
      }
      boundingBoxTemp[imageURL][id].push(sourceAnnotationDetail);
      toolStyle.setAnnotationStyles(
        sourceAnnotationDetail.annotation.annotationUID,
        {
          lineWidth: "2px",
          textBoxLinkLineWidth: "0",
          textBoxFontSize: "0px",
          color: color,
          colorSelected: color,
          colorHighlighted: color,
        }
      );
    }
  };

  const handleColorChange = (valId, valColor, data) => {
    data[valId].forEach((item) => {
      toolStyle.setAnnotationStyles(item.annotation.annotationUID, {
        lineWidth: "2px",
        textBoxLinkLineWidth: "0",
        textBoxFontSize: "0px",
        color: valColor,
        colorSelected: valColor,
        colorHighlighted: valColor,
      });
    });
  };

  const checkIfTextAnnotationExists = (annotationUID) => {
    for (const key in allTextToolAnnotation) {
      allTextToolAnnotation[key].map((item) => {
        const obj = JSON.parse(item);
        if (obj.annotationUID === annotationUID) {
          return false;
        }
      });
    }
    return true;
  };

  const disableMasking = ()=>{
    setIsCropEnable(false);
    setMaskingConfirm(() => {
      let newVal = { ...maskingConfirm };
      newVal.show = false;
      return newVal;
    });
      setPreviousActiveTool(activeTool);
    handleDefaultToolChange();
 
  }
 function getUpdatedMaskImages(prevMaskImages, annotationUID) {
  let didChange = false;
  let changedImageId = null;
  const updatedEntries = 
    Object.entries(prevMaskImages).map( ([id, mask]) => {
      const filteredAnnotations = mask.maskAnnotationData.filter(
        a => a.annotationUID !== annotationUID
      );
      if (filteredAnnotations.length !== mask.maskAnnotationData.length) {
        didChange = true;
        changedImageId = id;
        return [id, { ...mask, maskAnnotationData: filteredAnnotations }];
      }
      
      return [id, mask];
    })
    
  
  const updatedMaskImages = Object.fromEntries(updatedEntries);
  return { updatedMaskImages, changedImageId };
}

const removeCropAnnotaionData = async (annotationUID) => {
  const { updatedMaskImages, changedImageId } =  getUpdatedMaskImages(maskImages, annotationUID);
  
  if (changedImageId != null) {
     renderViewports();
  }
  setMaskImages(updatedMaskImages);
};

  
  

  useEffect(() => {
    eventTarget.addEventListener(completedEvt, async (e) => {
      let toolName = e.detail.annotation.metadata.toolName;
      
      if (
        toolName == "ArrowAnnotate" &&
        checkIfTextAnnotationExists(e.detail.annotation.annotationUID)
      ) {
        addTextAnnotationToDatabase(e.detail.annotation,true);
         
      }
    });

    eventTarget.addEventListener(updatedEvt, (e) => {
      let toolName = e.detail.annotation.metadata.toolName;
      if (
        toolName == "ArrowAnnotate" &&
        checkIfTextAnnotationExists(e.detail.annotation.annotationUID)
      ) {
        addTextAnnotationToDatabase(e.detail.annotation,false);
      }
    });
  }, []);

  const boundingBoxModeRef = useRef(boundingBoxMode);
  const activePathologyRef = useRef(null);
  const activeMaskingProfileRef = useRef(null);
  useEffect(() => {
    boundingBoxModeRef.current = boundingBoxMode;
    if(!boundingBoxMode) {
      activePathologyRef.current = {
        id: "",
        backgroundColor: "",
        pathologyName: "",
      };
      removeWarning();
    }
  }, [boundingBoxMode]);

  const handlePencilClick = (data, toolName) => {
     
    activePathologyRef.current = {
      id: data.id,
      backgroundColor: data.backgroundColor,
      pathologyName: data.pathalogyName,
    };
    hideBoundingBox(data.id, false);
    const addEvtCallback = (e) => {
      if(!boundingBoxModeRef.current)
        return;
      setBoundingBoxAdding("enabled");
      if(viewportSeriesData[e.detail.viewportId.slice(-1)].study != studyParentId) {
        const id = e.detail.annotation.annotationUID;
        removeAnnotation(id);
        
      } else {
        addMeasurement(e, activePathologyRef.current.id, activePathologyRef.current.pathologyName, activePathologyRef.current.backgroundColor);
      }
      
    };
    eventTarget.removeEventListener(addedEvt, addEvtCallback);
    eventTarget.addEventListener(addedEvt, addEvtCallback);
  };

  const hideBoundingBox = async (id, hide) => {
    if(boundingBoxMode)
      setBoundingBoxMode(false);
    const activeViewport = await getViewport(activeViewportIndex);
    let imageURL = activeViewport.getCurrentImageId();
    imageURL = extractImageUrl(imageURL);
    let boundingBoxTemp = annotationData[imageURL];

    if (
      boundingBoxTemp != undefined &&
      activeViewport?.element != undefined &&
      boundingBoxTemp[id] != undefined
    ) {
      boundingBoxTemp[id].forEach((item) => {
        annotation.visibility.setAnnotationVisibility(item.annotation.annotationUID, !hide);
      });

      renderViewports();
    }
  };

  const removeBB = (id) => {
    let isRender = false;
    for (let imageURLVar in annotationData) {
      for (let pathId in annotationData[imageURLVar]) {
        if (pathId == id) {
          annotationData[imageURLVar][id].forEach((item) => {
            let annotationUID = item.annotation.annotationUID;
            annotation.state.removeAnnotation(annotationUID);
            isRender = true;
          });
        }
      }
    }
    if(isRender)
      renderViewports();
  }

  const addAiBb = (id) => {
    let isRender = false;
    for (let imageURLVar in annotationDataAI) {
      for (let pathId in annotationDataAI[imageURLVar]) {
        if (pathId == id) {
          annotationDataAI[imageURLVar][id].forEach((item) => {
            let bb =  JSON.parse(JSON.stringify(item.annotation));
            annotation.state.addAnnotation(bb);
            isRender = true;
          });
        }
      }
    }
    if(isRender)
      renderViewports();
  };

  const changeAiBbVisibility = (id, isVisible) => {
    let isRender = false;
    for (let imageURLVar in annotationDataAI) {
      for (let pathId in annotationDataAI[imageURLVar]) {
        if (pathId == id) {
          if(annotationDataAI[imageURLVar][id]) {
            annotationDataAI[imageURLVar][id].forEach((item) => {
              const annotationUID = item.annotation.annotationUID;
              if(annotation.state.getAnnotation(annotationUID)) {
                annotation.visibility.setAnnotationVisibility(annotationUID, isVisible);
                isRender = true;
              }
            });
          }
        }
      }
    }
    if(isRender)
      renderViewports();
  };

  const handleRemovingAndAddingOfBB = (transferFromAIData, imageURL, id) => {
      if(transferFromAIData){
        let toTransfer = JSON.parse(JSON.stringify(annotationDataAI[imageURL][id]));
        if (imageURL != "") {
          if (!annotationData[imageURL]) {
            annotationData[imageURL] = [];
          }
          if (
            !annotationData[imageURL][id] ||
            annotationData[imageURL][id].length >= 0
          ) {
            annotationData[imageURL][id] = toTransfer;
          }
        }
      }else{
          setAnnotationData((prevState) => {
            const newState = { ...prevState };
            const { [id]: _, ...rest } = newState[imageURL];
            newState[imageURL] = rest;
            return newState;
          });
      }
  }

  const addLockedAIPathology = (id, addOrRemove) => {
    let imageURL = "";
    let render = false;
    if (addOrRemove) {
      for (let imageURLVar in annotationDataAI) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == id) {
            imageURL = imageURLVar;
            handleRemovingAndAddingOfBB(true, imageURLVar, id);
            break;
          }
        }
      }
    } else {
      for (let imageURLVar in annotationData) {
        for (let pathId in annotationData[imageURLVar]) {
          if (pathId == id) {
            annotationData[imageURLVar][pathId].map((item) => {
              if (item != null || item != undefined) {
                annotation.state.removeAnnotation(item.annotation.annotationUID);
                render =  true;
              }
            });
            handleRemovingAndAddingOfBB(false, imageURLVar, id);
            break;
          }
        }
      }
      for (let imageURLVar in annotationDataAI) {
        for (let pathId in annotationDataAI[imageURLVar]) {
          if (pathId == id) {
            annotationDataAI[imageURLVar][pathId].map((item) => {
              if (item) {
                const bb = JSON.parse(JSON.stringify(item.annotation));
                annotation.state.addAnnotation(bb);
                render = true;
              }
            });
            break;
          }
        }
      }
    }
    if(render)
      renderViewports();
    return true;
  };

  const handleChangeLabelForTextAnnotation = (annotationVal) => {
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
    for (const key in allTextToolAnnotation) {
      allTextToolAnnotation[key].map((item) => {
        const obj = JSON.parse(item);
        if (obj.annotationUID === annotationVal.annotationUID) {
          let measurement = annotation.state.getAnnotation(
            annotationVal.annotationUID
          );
          const userInput = window.prompt("Change Label: ");

          if (userInput !== null) {
            measurement.data.text = userInput;
            updateTextInSavedTextAnnotation(
              measurement.metadata.referencedImageId,
              annotationVal.annotationUID,
              userInput
            );
          }
        }
      });
    }
    return true;
  };

  const updateTextInSavedTextAnnotation = (imageURL, annotationUID, text) => {
    const annotationDataTemp = { ...allTextToolAnnotation };
    imageURL = extractImageUrl(imageURL);

    if (annotationDataTemp[imageURL]) {
      // Use map to update the text property
      annotationDataTemp[imageURL] = annotationDataTemp[imageURL].map(
        (item) => {
          const parseJSON = JSON.parse(item);
          if (parseJSON.annotationUID === annotationUID) {
            parseJSON.text = text;
          }
          return JSON.stringify(parseJSON);
        }
      );
    }
    setAllTextToolAnnotation(annotationDataTemp);
  };

  const handleRemoveBoundingBox = (annotationVal) => {
    let imageURL = annotationVal.metadata.referencedImageId;
    annotation.state.removeAnnotation(annotationVal.annotationUID);
    removeBoundingBoxFromObject(imageURL, annotationVal.annotationUID);
    removeCropAnnotaionData(annotationVal.annotationUID);
    setContextMenuOpen(() => {
      const newVal = { ...contextMenuOpen };
      newVal.open = false;
      newVal.mouseEvt = null;
      newVal.data = null;
      return newVal;
    });
    renderViewports();
  };

  const handleDeleteSmartTag = (smartTag) => {
    setBoundingBoxMode(false);
    let isRender = false;
    for (const key in annotationData) {
      for (const key2 in annotationData[key]) {
        if (
          smartTag.id == key2 &&
          annotationData[key][key2] != undefined &&
          annotationData[key][key2].length > 0
        ) {
          annotationData[key][key2].map((item) => {
            if (item != null || item != undefined) {
              if(item.annotation?.annotationUID) {
                
                annotation.state.removeAnnotation(item.annotation.annotationUID);
                removeBoundingBoxFromObject(
                  item.annotation.metadata.referencedImageId,
                  item.annotation.annotationUID
                );
                isRender = true;
              }
            }
          });
        }
      }
    }
    for (const imageURLVar in annotationDataAI) {
      for (const pathId in annotationDataAI[imageURLVar]) {
        if (smartTag.id == pathId) {
          annotationDataAI[imageURLVar][pathId].forEach((item) => {
            annotation.state.removeAnnotation(item.annotation.annotationUID);
            isRender = true;
          });
        }
      }
    }    
    if(isRender)
      renderViewports();
  };

  const removeBoundingBoxFromObject = (imageURL, annotationUID) => {
    let annotationDataTemp = annotationData;
    imageURL = extractImageUrl(imageURL);
    let temp = annotationDataTemp[imageURL];
    let updateValues = temp;
    for (const key in temp) {
      updateValues[key] = temp[key].filter((item) => {
        if (item.annotation.annotationUID != annotationUID) {
          return item;
        }
      });
    }
    if (annotationData[imageURL]) {
      annotationDataTemp[imageURL] = updateValues;
    }
    setAnnotationData(annotationDataTemp);
    return true;
  };

  const removeTextAnnotationFromObject = (imageURL, annotationUID) => {
    let annotationDataTemp = allTextToolAnnotation;
    imageURL = extractImageUrl(imageURL);
    let temp = allTextToolAnnotation;
    let updateValues = temp;
    for (const key in temp) {
      updateValues = temp[key].filter((item) => {
        let parseJSON = JSON.parse(item);
        if (parseJSON.annotationUID != annotationUID) {
          return parseJSON;
        }
      });
    }
    if (allTextToolAnnotation[imageURL]) {
      annotationDataTemp[imageURL] = updateValues;
    }
    setAllTextToolAnnotation(annotationDataTemp);
  };

  const checkBoundingBoxExistPathalogy = (id) => {
    const keys = Object.keys(annotationData);

    for (const key in annotationData) {
      for (const key2 in annotationData[key]) {
        if (
          id == key2 &&
          annotationData[key][key2] != undefined &&
          annotationData[key][key2].length > 0
        ) {
          return true;
        }
      }
    }
    return false;

    // keys.forEach((key2, index) => {
    //   const keys2 = Object.keys(annotationData[key2]);
    //   keys2.forEach((key3,index)=>{
     //   })
    // });
  };

  const [originalImageActiveState, setOriginalImageActiveState] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const addViewportElement = (element) => {
    tempViewportElements.push(element);
    setViewportElements(tempViewportElements);
  };

  const changeActiveViewportIndex = (index) => {
    setActiveViewportIndex(index);
  };

  const changeViewportSeriesData = (
    stack,
    study,
    studyIdDisplay,
    series,
    modality,
    index,
    patientId,
    patientAge,
    patientSex,
    patientName,
    studyDescription,
    studyDate,
    thumbnailIndex,
    originalStack,
    heatmapStack,
    outlineStack,
    orderId
  ) => {
    const tempViewportSeriesData = viewportSeriesData.map((data, i) => {
      if (i === index) {
        return {
          stack,
          study,
          studyIdDisplay,
          series,
          modality,
          patientId,
          patientAge,
          patientSex,
          patientName,
          studyDescription,
          studyDate,
          thumbnailIndex,
          originalStack,
          heatmapStack,
          outlineStack,
          orderId
        };
      }
      return data;
    });

    setViewportSeriesData(tempViewportSeriesData);
  };

  const changeViewportSeriesDataUpdated = (
    stack,
    study,
    studyIdDisplay,
    series,
    modality,
    index,
    patientId,
    patientAge,
    patientSex,
    patientName,
    studyDescription,
    studyDate,
    thumbnailIndex,
    originalStack,
    heatmapStack,
    outlineStack,
    orderId
  ) => {
    setViewportSeriesData(prevData => {
      // Create a shallow copy of the previous state array
      const updatedData = [...prevData];
  
      // Update only the specific index with new data
      updatedData[index] = {
        stack,
        study,
        studyIdDisplay,
        series,
        modality,
        patientId,
        patientAge,
        patientSex,
        patientName,
        studyDescription,
        studyDate,
        thumbnailIndex,
        originalStack,
        heatmapStack,
        outlineStack,
        orderId
      };
  
      // Return the updated array
      return updatedData;
    });
  };
  

  const changeLayout = (row, column) => {
    setViewportRow(row);
    setViewportColumn(column);
  };

  const handleDefaultToolChange = () => {
    if(isMPRActive) {
      if(SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(activeModality)){
        setActiveMPRTool(XRAY_DEFAULT_TOOL);
      }else{
        if (activeMPRTool !== DEFAULT_TOOL) {
          setActiveMPRTool(DEFAULT_TOOL);
        }
      }
    } else {
      if(SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(activeModality)){
        setActiveTool(XRAY_DEFAULT_TOOL);
      }else{
        if (activeTool !== DEFAULT_TOOL) {
          setActiveTool(DEFAULT_TOOL);
        }
      }
    }
  }

  const activeThumbnailIndexRef = useRef(activeThumbnailIndex);
  useEffect(() => {
    activeThumbnailIndexRef.current = activeThumbnailIndex;
  }, [activeThumbnailIndex]);

  const priorStudyDataRef = useRef(priorStudyData);
  useEffect(() => {
    priorStudyDataRef.current = priorStudyData;
  }, [priorStudyData]);

  const activeStudyIdRef = useRef(activeStudyId);
  useEffect(() => {
    activeStudyIdRef.current = activeStudyId;
  }, [activeStudyId]);

  const studyDataRef = useRef(studyData);
  useEffect(() => {
    studyDataRef.current = studyData;
  }, [studyData]);

  const isSynchronizedEnabledDataRef = useRef(isSynchronizedEnabled);
  useEffect(() => {
    isSynchronizedEnabledDataRef.current = isSynchronizedEnabled;
  }, [isSynchronizedEnabled]);

  const viewportSeriesDataRef = useRef(viewportSeriesData);
  useEffect(() => {
    viewportSeriesDataRef.current = viewportSeriesData;
  }, [viewportSeriesData]);

  const setActiveOnSeriesScroll = (viewportIndex, viewportModality) => {
    if (isSynchronizedEnabledDataRef.current) {
      enableStackScrollSync(viewportIndex);
    } else {
      disableStackScrollSync();
    }
    setActiveViewportModality(viewportModality);
    changeActiveViewportIndex(viewportIndex);
    
    changeActiveThumbnailIndex(
      viewportSeriesDataRef.current[viewportIndex].thumbnailIndex
    );
    setActiveModality(viewportModality);
    let studyIdString = viewportSeriesDataRef.current[viewportIndex].study;
    let studyIdInteger = parseInt(studyIdString, 10);
    setActiveStudyId(studyIdInteger);
    
  };

  // Find the active study index from the prior study list
  const getActivePriorStudyData = () => {
    let activePriorStudyIndex = -1;
    let activeStudyIndexStart = 0;
    let activeStudyIndexEnd = 0;
    let activePriorStudy = {};
    //let priorStudy = 
    // prior study
    for (let i = 0; i < priorStudyDataRef.current.length; i++) {
      const priorStudy = priorStudyDataRef.current[i];
    
      if (activeStudyIdRef.current === priorStudy.studyId) {
        activePriorStudy = priorStudy;
        activePriorStudyIndex = i;
        activeStudyIndexEnd = activeStudyIndexStart + priorStudy.stacks.length - 1;
        break; // Exit the loop when the condition is met
      } else {
        activeStudyIndexStart += priorStudy.stacks.length;
      }
    }
    
    return {
      activePriorStudy: activePriorStudy,
      activePriorStudyIndex: activePriorStudyIndex,
      activeStudyIndexStart: activeStudyIndexStart,
      activeStudyIndexEnd: activeStudyIndexEnd
    };
  }

 




  // Define the seriesScrollCallback function
  const seriesScrollCallback = (viewport, delta) => {
    const currentImage = viewport.getCurrentImageIdIndex();
    const viewportIndex = parseInt(viewport.id.split('_')[1]);

    
    if(viewportIndex !== activeViewportIndex) {
      const viewportModality = viewport.modality;
      setActiveOnSeriesScroll(viewportIndex, viewportModality);
    }
    const activeThumbnailIndexCurrent = parseInt(activeThumbnailIndexRef.current);
 
    setIsScrollingUp(false);
    if(delta > 0 && currentImage === (viewport.imageIds.length - 1)) {
      if(priorStudyDataRef.current != undefined && priorStudyDataRef.current.length > 1) {
        const activePriorStudyData = getActivePriorStudyData();
        const noOfStacksInActiveStudy = activePriorStudyData.activePriorStudy.stacks.length;
        if(activePriorStudyData.activePriorStudyIndex != -1 && noOfStacksInActiveStudy > 1) {
          if(activeThumbnailIndexCurrent < activePriorStudyData.activeStudyIndexEnd)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent + 1);
          else {
            setStackScrollActiveThumbnailIndex(activePriorStudyData.activeStudyIndexStart);
          }
         }
      } else {
        // single study
        let noOfStacksInActiveStudy = studyDataRef.current?.stacks ? studyDataRef.current?.stacks.length: 0;
        if(noOfStacksInActiveStudy > 1) {
          if(activeThumbnailIndexCurrent < (noOfStacksInActiveStudy - 1))
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent + 1);
          else
            setStackScrollActiveThumbnailIndex(0);
        }
      }
    } else if (delta < 0 && currentImage == 0) {
      if(priorStudyDataRef.current != undefined && priorStudyDataRef.current.length > 1) {
        const activePriorStudyData = getActivePriorStudyData();
        const noOfStacksInActiveStudy = activePriorStudyData.activePriorStudy.stacks.length;
        if(activePriorStudyData.activePriorStudyIndex != -1 && noOfStacksInActiveStudy > 1) {
          setIsScrollingUp(true);
          if(activeThumbnailIndexCurrent > activePriorStudyData.activeStudyIndexStart)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent - 1);
          else
            setStackScrollActiveThumbnailIndex(activePriorStudyData.activeStudyIndexEnd);
        }
      } else {
        // single study
        let noOfStacksInActiveStudy = studyDataRef.current?.stacks ? studyDataRef.current?.stacks.length: 0;
        if(noOfStacksInActiveStudy > 1) {
          setIsScrollingUp(true);
          if(activeThumbnailIndexCurrent > 0)
            setStackScrollActiveThumbnailIndex(activeThumbnailIndexCurrent - 1);
          else 
            setStackScrollActiveThumbnailIndex(noOfStacksInActiveStudy - 1);
        }
      }
   }    
  };

  useEffect(() => {
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length ){
      console.log("=========applied hp=========");
      console.log(appliedHp);
      setViewportRow(0);
      setViewportColumn(0);
      clearViewportSeriesData();
      setIsHpApplied(true);
    }
  },[appliedHp]);

  useEffect(() => {
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length &&
     viewportColumn == 0){
        applyHangingProtocol();
    }
  },[appliedHp, viewportColumn]);

  useEffect(() => {
    if (hpDataList && Object.keys(hpDataList).length !== 0 && !isMobile) {
      const run = async () => {
        const hpPercentage = await calculateHpDtoMatchPercentage();
        setHpPercentageMap(hpPercentage);
        if (!hpPercentage || hpPercentage.size === 0) {
          setHpNotFound(true);
        }
      };
      run();
    }
  },[hpDataList]);

  useEffect(() =>{
    if (hpPercentageMap.size > 0) { 
      const bestMatchingHp = getMaxPercentageHp(hpPercentageMap);
      if(bestMatchingHp){
        setAppliedHp(bestMatchingHp);
      }else{
        setHpNotFound(true);
      }
    }
  }, [hpPercentageMap]);

  const getMaxPercentageHp = (matchPercentageMap) => {
    if (!hpDataList.length || !matchPercentageMap.size) return null;
  
    let maxHpDto = null;
    let maxPercentage = 0;
    let maxConditionsCount = 0;
  
    hpDataList.forEach(hpDto => {
      const percentage = matchPercentageMap.get(hpDto.name) || 0;
  
      if (percentage > maxPercentage) {
        maxPercentage = percentage;
        maxHpDto = hpDto;
        maxConditionsCount = countHpDtoConditions(hpDto);
      } else if (percentage === maxPercentage) {
        const currentConditionsCount = countHpDtoConditions(hpDto);
        if (currentConditionsCount > maxConditionsCount) {
          maxHpDto = hpDto;
          maxConditionsCount = currentConditionsCount;
        }
      }
    });
  
    return maxPercentage != 0 ? maxHpDto : null;
  };

  const countHpDtoConditions = (hpDto) => {
    let count = 0;
  
    hpDto.layout.viewportList.forEach(viewport => {
      count += (viewport.seriesConditions?.length || 0);
      count += (viewport.imageConditions?.length || 0);
    });
  
    return count;
  };

  const calculateHpDtoMatchPercentage = async () => {
    let matchPercentageMap = new Map();
  
    for (const hpDto of hpDataList) {

      const viewportDataMap = new Map();

      for (const viewport of hpDto.layout.viewportList) {
        
        let matchingStackIndex = -1
        let matchingImageIndex = -1;
        const studyDatasSet = priorStudyData && priorStudyData.length > 0 ? priorStudyData[0] : studyData;
        const matchingStackIndices = studyDatasSet.stacks
          .map((stack, index) => ({ index, matches: checkSeriesConditions(stack, viewport.seriesConditions) }))
          .filter(stack => stack.matches)
          .map(stack => stack.index); 
        
        for (const stackIndex of matchingStackIndices) {

          matchingImageIndex = await findMatchingImageIndex(studyDatasSet, stackIndex, viewport);
          // matchingImageIndex = studyDatasSet.stacks[stackIndex]?.images?.findIndex(stack =>
          //   checkImageConditions(stack, viewport.imageConditions, studyDatasSet.stacks[stackIndex]?.imageIds[0])
          // );
        
          if (matchingImageIndex !== -1) {
            matchingStackIndex = stackIndex;
            const key = `${viewport.row}-${viewport.column}`;
            viewportDataMap.set(key, {
              row: viewport.row,
              column: viewport.column,
              matchingStackIndex,
              matchingImageIndex,
            });
            break;
          }
        }
      }

      const totalViewports = hpDto.layout.rows * hpDto.layout.columns;

      const matchedViewports = viewportDataMap.size;
      const matchPercentage = (matchedViewports / totalViewports) * 100;

      matchPercentageMap.set(hpDto.name, matchPercentage);
      setHpViewportMap(prevMap => {
        const newMap = new Map(prevMap); 
        newMap.set(hpDto.name, viewportDataMap); 
        return newMap;
      });
    }
    return matchPercentageMap;
  };

  async function findMatchingImageIndex(studyDatasSet, stackIndex, viewport) {
    const images = studyDatasSet.stacks[stackIndex]?.images || [];
    const imageId = studyDatasSet.stacks[stackIndex]?.imageIds[0];

    const allEmpty = viewport.imageConditions?.every(cond =>
      !cond.operand && 
      (cond.operandValue === null || cond.operandValue === '') &&
      !cond.tag &&
      (cond.tagValue === null || cond.tagValue === '') &&
      (cond.value === null || cond.value === '')
    );
  
    if (allEmpty) {
      return 0;
    }
  
    for (let i = 0; i < images.length; i++) {
      const stack = images[i];
      const matches = await checkImageConditions(stack, viewport.imageConditions, imageId);
      if (matches) return i;
    }
  
    return -1;
  }

  useEffect(() =>{
    console.log("hpViewportMap");
    console.log(hpViewportMap);
  },[hpViewportMap])
  

  const applyHangingProtocol = async () =>{
    if(appliedHp && appliedHp != undefined && Object.keys(appliedHp).length ){
      setHpLoading(true);
      // await clearViewportSeriesData();

      const layout = appliedHp.layout;
      changeLayout(layout.rows, layout.columns);

      const newMatchingStackIndices = [];

      layout.viewportList.map((viewport, index) => {
        const viewportIndexes = hpViewportMap.get(appliedHp.name)?.get(`${viewport.row}-${viewport.column}`);
        const matchingStackIndex= viewportIndexes ? viewportIndexes.matchingStackIndex : -1;
        const matchingImageIndex= viewportIndexes ? viewportIndexes.matchingImageIndex : -1;
        
        if (matchingStackIndex !== -1 && matchingImageIndex !== -1) {
          const matchingStack = priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].stacks[matchingStackIndex] : studyData.stacks[matchingStackIndex];
          const index = (viewport.row - 1) * 3 + (viewport.column - 1);
        
          console.log(`Row: ${viewport.row}, Column: ${viewport.column}, Index: ${index}`);

          changeViewportSeriesDataUpdated(
              matchingStack,
              matchingStack.studyId,
              matchingStack.studyIdDisplay,
              matchingStack.stackId,
              matchingStack.modality,
              index,
              matchingStack.patientId,
              matchingStack.patientAge,
              matchingStack.patientSex,
              matchingStack.patientName,
              matchingStack.studyDescription,
              matchingStack.studyDate,
              matchingStackIndex,
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].originalStacks[matchingStackIndex] : studyData.originalStacks[matchingStackIndex],
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].heatmapStacks[matchingStackIndex] : studyData.heatmapStacks[matchingStackIndex],
              priorStudyData && priorStudyData.length > 0 ? priorStudyData[0].outlineStacks[matchingStackIndex] : studyData.outlineStacks[matchingStackIndex],
              matchingStack.orderId
          );

          newMatchingStackIndices.push(matchingStackIndex);

          setViewportHpLayout(prevMap => {
            const newMap = new Map(prevMap);
            newMap.set(index, viewport);
            return newMap;
          });

          setViewportHpImage(prevMap => {
            const newMap = new Map(prevMap);
            newMap.set(index, matchingImageIndex);
            return newMap;
          });
        }
      });

      setHPThumbnailIds(newMatchingStackIndices); 
    }
  }

  function checkSeriesConditions(stack, conditions) {
    return conditions.every(condition => checkCondition(stack, condition));
  }
  
  async function checkImageConditions(stack, conditions, imageId) {
    for (const condition of conditions) {
      const result = await checkImageCondition(stack, condition, imageId);
      if (!result) return false;
    }
    return true;
  }

  async function checkImageCondition(stack, condition, imageId) {
    let tagValue;
  
    switch (condition.tag) {
      case HP_META_TAGS.SOP_CLASS_UID:
        tagValue = stack.sopClassUID;
        return evaluateCondition(tagValue, condition.operand, condition.value);
      case HP_META_TAGS.INSTANCE_NUMBER:
        tagValue = stack.instanceNumber;
        return evaluateCondition(tagValue, condition.operand, condition.value);
    }
  
    let image = imageCacheRef.current.get(imageId);

    if (!image) {
      console.warn("Image not found in cache. Loading on demand.");
      image = await loadAndCacheImage(imageId);
      if (image) {
        imageCacheRef.current.set(imageId, image);
      } else {
        return false;
      }
    }
  
    return evaluateTagCondition(image.data, condition);
  }
  
  function evaluateTagCondition(data, condition) {
    if (!data) {
      console.warn("Image data is not loaded.");
      return false;
    }
  
    let tagValue;
  
    switch (condition.tag) {
      case HP_META_TAGS.SAMPLES_PER_PIXEL:
        tagValue = data?.uint16('x00280002');
        break;
      case HP_META_TAGS.IMAGE_TYPE:
        tagValue = data?.string('x00080008');
        break;
      case HP_META_TAGS.IMAGE_LATERALITY:
        tagValue = data?.string('x00200062');
        break;
      case HP_META_TAGS.PATIENT_ORIENTATION:
        tagValue = data?.string('x00200020');
        break;
      case HP_META_TAGS.VIEW_POSITION:
        tagValue = data?.string('x00185101');
        break;
      case HP_META_TAGS.TRANSFER_SYNTAX_UID:
        tagValue = data?.string('x00020010');
        break;
      default:
        console.log("Unknown tag:", condition.tag);
        return false;
    }
  
    return evaluateCondition(tagValue, condition.operand, condition.value);
  }
  
  function checkCondition(stack, condition) {
    let tagValue;

    // Map tag to the stack property using constants
    switch (condition.tag) {
        case HP_META_TAGS.MODALITY:
            tagValue = stack.modality;
            break;
        case HP_META_TAGS.BODY_PART_EXAMINED:
            tagValue = stack.bodyPart;
            break;
        case HP_META_TAGS.STUDY_DESCRIPTION:
            tagValue = stack.studyDescription;
            break;
        case HP_META_TAGS.SERIES_DESCRIPTION:
            tagValue = stack.seriesDescription;
            break;
        case HP_META_TAGS.SERIES_NUMBER:
            tagValue = stack.stackId;
            break;
        default:
            console.log("Unknown tag:", condition.tag);
            return false;
    }
    return evaluateCondition(tagValue, condition.operand, condition.value);
  }

function evaluateCondition(tagValue, operand, value) {
  if(tagValue == undefined){
    return false;
  }
  
  if (typeof tagValue === "string" && typeof value === "string") {
    tagValue = normalizeString(tagValue.toLowerCase());
    value = normalizeString(value.toLowerCase());
  }
  switch (operand) {
    case HP_OPERANDS.EQUALS:
      return tagValue == value;
    case HP_OPERANDS.NOT_EQUALS:
      return tagValue !== value;
    case HP_OPERANDS.CONTAINS:
      return String(tagValue).toLowerCase().includes(String(value).toLowerCase());
    case HP_OPERANDS.LESS_THAN:
      return tagValue < value;
    case HP_OPERANDS.GREATER_THAN:
      return tagValue > value;
    case HP_OPERANDS.LESS_THAN_EQUALS:
      return tagValue <= value;
    case HP_OPERANDS.GREATER_THAN_EQUALS:
      return tagValue >= value;
    default:
      console.log("Unknown operand:", operand);
      return false;
  }
}

function normalizeString(str) {
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
}

 const clearViewportSeriesData = () => {
  setViewportSeriesData(() => {
    let array = [];
    for (let i = 0; i < VIEWPORT_COLUMN * VIEWPORT_ROW; i++) {
      array.push({ study: "", stack: "", modality: "" });
    }
    return array;
  });
}
useEffect(() =>{
  console.log("=========viewportSeriesData==========");
  console.log(viewportSeriesData);
},[viewportSeriesData]);

// useEffect(() =>{
//   if (thumbnailLoadingComplete && !isMobile && hpDataList && hpDataList != undefined && Object.keys(hpDataList).length !== 0) {
//     loadAllThumbnailImages()
//   }
// },[thumbnailLoadingComplete, hpDataList]);

// const loadAllThumbnailImages = async () => {
//      await loadThumbnailImages();
// };

// const loadThumbnailImages = async () => {
//   const allThumbnailViewports = await getAllThumbnailViewports();

//   for (let i = 0; i < allThumbnailViewports.length; i++) {
//     const image = await loadAndCacheImage(
//       allThumbnailViewports[i].imageIds[0]
//     );
//     imageCacheRef.current.set(allThumbnailViewports[i].imageIds[0], image);
//   }

//   setThumbnailImageLoadedAndCached(true);
// }

const handleRemoveWarning = () => {
  if(!isCreatingMaskingProfile){
     setEditWarning(() => {
      let newVal = { ...editWarning };
      newVal.show = false;
      newVal.success = false;
      newVal.id = null;
      newVal.name = "";
      return newVal;
    });
    setDisableAddPathology(false);
    setPreviousActiveTool(activeTool);
    handleDefaultToolChange();
    setBoundingBoxMode(false);
  }
};

const handleRemoveMaskWarning = () => {
  setEditWarning(() => {
    let newVal = { ...editWarning };
    newVal.show = false;
    newVal.success = false;
    newVal.id = null;
    newVal.name = "";
    return newVal;
  });
  setIsCreatingMaskingProfile(false);
  removeOldMaskedAnnotations();
  addMaskedBoundingBoxesToViewport();
  // setDisableAddPathology(false);
  // setPreviousActiveTool(activeTool);
  handleDefaultToolChange();
  setBoundingBoxMode(false);
};

const removeWarning = () => {
  setEditWarning(() => {
    let newVal = { ...editWarning };
    newVal.show = false;
    newVal.success = false;
    newVal.id = null;
    newVal.name = "";
    return newVal;
  });
};
const [sharedSlabThickness, setSharedSlabThickness] = useState(0.05);
const [sharedMprBlendMode, setSharedMprBlendMode] = useState("MIP"); 

  return (
    <ViewportContext.Provider
      value={{
        sharedSlabThickness,
        setSharedSlabThickness,
        sharedMprBlendMode,
        setSharedMprBlendMode,
        activeViewportIndex,
        viewportRow,
        viewportColumn,
        changeActiveViewportIndex,
        changeLayout,
        viewportElements,
        changeViewportSeriesData,
        viewportSeriesData,
        addViewportElement,
        activeTool,
        setActiveTool,
        previousActiveTool,
        setPreviousActiveTool,
        showOverlay,
        setShowOverlay,
        testPatientViewerParent,
        setTestPatientViewerParent,
        handlePencilClick,
        boundingBox,
        currentActiveTag,
        setCurrentActiveTag,
        activeId,
        setActiveId,
        activeColor,
        setActiveColor,
        hideBoundingBox,
        contextMenuOpen,
        setContextMenuOpen,
        handleRemoveBoundingBox,
        originalImageActiveState,
        setOriginalImageActiveState,
        annotationData,
        setEditWarning,
        editWarning,
        checkBoundingBoxExistPathalogy,
        handleDeleteSmartTag,
        setIsCineEnabled,
        isCineEnabled,
        disableAddPathology,
        setDisableAddPathology,
        setIsSynchronizedEnabled,
        isSynchronizedEnabled,
        annotationDataAI,
        setAnnotationDataAI,
        removeBB,
        addAiBb,
        addLockedAIPathology,
        setAnnotationAddedSuccess,
        // databasePointsToMeasurement,
        addedAnnotation,
        setAddedAnnotation,
        isMPRActive,
        setIsMPRActive,
        mprViewportElements,
        setMprViewportElements,
        mprLoading,
        setMprLoading,
        activeMPRViewportIndex,
        setActiveMPRViewportIndex,
        activeMPRTool,
        setActiveMPRTool,
        previousActiveMPRTool,
        setPreviousActiveMPRTool,
        mprSeriesData,
        setMprSeriesData,
        dragEvent,
        setDragEvent,
        thumbnailDropEvent,
        setThumbnailDropEvent,
        thumbnailClickEvent,
        setThumbnailClickEvent,
        activeViewportModality,
        setActiveViewportModality,
        addBoundingBoxToViewport,
        studyBoundingBox,
        restoreBoundingBox,
        isMPRCineEnabled,
        setIsMPRCineEnabled,
        isCompareActive,
        setIsCompareActive,
        showCompare,
        setShowCompare,
        showImpressions,
        setShowImpressions,
        isSagittalActive,
        setIsSagittalActive,
        isAxialActive,
        setIsAxialActive,
        isCoronalActive,
        setIsCoronalActive,
        isReferenceLinesEnabled,
        setIsReferenceLinesEnabled,
        allTextToolAnnotation,
        setAllTextToolAnnotation,
        addTextAnnotationToViewport,
        setAllowAddingTextAnnotation,
        isMPRViewportActivate,
        setIsMPRViewportActivated,
        allowAddingTextAnnotation,
        addedStoreAnnotation,
        setAddedStoreAnnotation,
        archivedPathology,
        setArchivedPathology,
        handleChangeLabelForTextAnnotation,
        isChildStudyActive,
        showPriorStudyTopBar,
        setShowPriorStudyTopBar,
        isReferenceLineActivated,
        setIsReferenceLineActivated,
        imageLoadedOnViewport,
        setImageLoadedOnViewport,
        updateBBPosition,
        isUserInfoClicked, setIsUserInfoClicked,
        viewportLoadingComplete, setViewportLoadingComplete,
        mprViewportLoaderRunning, setMPRViewportLoaderRunning,
        volumeId, setVolumeId,
        handleDefaultToolChange,
        isScrollingUp,
        setIsScrollingUp,
        seriesScrollCallback,
        viewportHpLayout,
        viewportHpImage,
        setViewportRow,
        setViewportColumn,
        viewportOldState,
        setViewportOldState,
        setViewportSeriesData,
        updateViewportProperties,
        viewportStates,
        viewportDoubleClickIndex, setViewportDoubleClickIndex,
        viewportDoubleClickIndexConst, setViewportDoubleClickIndexConst,
        isMPREnabled,
        setIsMPREnabled,
        boundingBoxMode,
        setBoundingBoxMode,
        handleRemoveWarning,
        handleRemoveMaskWarning,
        changeAiBbVisibility,
        applyHangingProtocol,
        hPThumbnailIds,
        boundingBoxAdding, setBoundingBoxAdding, handleAddMaskingProfile, maskingProfileData, setMaskingProfileData, isCreatingMaskingProfile, setIsCreatingMaskingProfile,
        isSrSelected, setIsSrSelected, addBlackMaskOverlayOnViewport, isMaskingEnabled, setIsMaskingEnabled,
        removeOldMaskedAnnotations, addMaskedBoundingBoxesToViewport,
       
        isCropEnable , setIsCropEnable,
        maskingConfirm, setMaskingConfirm,
        disableMasking,


      }}
    >
      {props.children}
    </ViewportContext.Provider>
  );
};

export default ViewportState;
